import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { useRef } from "react";

function Login() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  // const jwtToken = localStorage.getItem("token") || "";
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [token, setToken] = useState(null);

  const sentRef = useRef(false);

  useEffect(() => {
    if (token && token !== "") {
      // ✅ only send once after login
      console.log("Sending token to extension:", token);
      window.postMessage(
        { type: "EXTENSION_AUTH", token: token },
        window.location.origin,
      );
      sentRef.current = true;
    }
    if (user?.id) {
      navigate("/shift");
    }
  }, [navigate, user, token]);

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false); // Track loading state

  const getLocalDate = () => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  };

  const onSubmit = async (data) => {
    setLoading(true);
    setStatus("");
    try {
      const response = await axios.post(`${API_BASE_URL}/auth/login`, data);
      if (response.status === 200) {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("user", JSON.stringify(response.data.user));
        localStorage.setItem("lastLoginDate", getLocalDate());
        setToken(response.data.token);
        // navigate("/dashboard");
      } else {
        //  console.log(response);
      }
    } catch (err) {
      setStatus(err.response || "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Loader (Shown only when loading) */}
      {loading && (
        <div id="global-loader">
          <div className="page-loader"></div>
        </div>
      )}

      <div className="main-wrapper">
        <div className="container-fuild">
          <div className="w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
            <div className="row">
              <div className="col-lg-5">
                <div className="d-lg-flex align-items-center justify-content-center d-none flex-wrap vh-100 bg-primary-transparent">
                  <div>
                    <img
                      src="assets/img/bg/authentication-bg-03.svg"
                      alt="Img"
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-7 col-md-12 col-sm-12">
                <div className="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap">
                  <div className="col-md-7 mx-auto vh-100">
                    <form className="vh-100" onSubmit={handleSubmit(onSubmit)}>
                      <div className="vh-100 d-flex flex-column justify-content-between p-4 pb-0">
                        <div className=" mx-auto mb-5 text-center">
                          <img
                            style={{ width: "127px", height: "50px" }}
                            src="/assets/img/logo.png"
                            className="img-fluid"
                            alt="Logo"
                          />
                        </div>
                        <div className="">
                          <div className="text-center mb-3">
                            <h2 className="mb-2">Sign In</h2>
                            <p
                              className={
                                status.status === 200
                                  ? "text-success text-center mb-0"
                                  : "text-danger text-center mb-0"
                              }
                            >
                              {status.data}
                            </p>
                          </div>
                          <div className="mb-3">
                            <label className="form-label">
                              Username
                              <span className="text-danger">
                                *{" "}
                                {errors.username?.type === "required" &&
                                  "Username is required"}
                              </span>
                            </label>
                            <div className="pass-group">
                              <input
                                type="text"
                                className="form-control"
                                {...register("username", { required: true })}
                              />
                              <span className="ti toggle-password ti-user"></span>

                              {/* <input type="text" {...register("username", { required: true })} className="form-control border-end-0" />
                              <span className="input-group-text border-start-0"><i className="ti ti-user"></i></span> */}
                            </div>
                          </div>
                          <div className="mb-3">
                            <label className="form-label">
                              Password
                              <span className="text-danger">
                                *{" "}
                                {errors.password?.type === "required" &&
                                  "Password is required"}
                              </span>
                            </label>
                            <div className="pass-group">
                              <input
                                type="password"
                                className="pass-input form-control"
                                {...register("password", { required: true })}
                              />
                              <span className="ti toggle-password ti-eye-off"></span>
                            </div>
                          </div>
                          <div className="d-flex align-items-center justify-content-between mb-3">
                            <div className="d-flex align-items-center">
                              <div className="form-check form-check-md mb-0">
                                <input
                                  className="form-check-input"
                                  id="remember_me"
                                  type="checkbox"
                                />
                                <label
                                  htmlFor="remember_me"
                                  className="form-check-label mt-0"
                                >
                                  Remember Me
                                </label>
                              </div>
                            </div>
                            <div className="text-end">
                              <Link
                                to="/forgot-password"
                                className="text-danger"
                              >
                                Forgot Password ?
                              </Link>
                            </div>
                          </div>
                          <div className="mb-3">
                            <button
                              type="submit"
                              className="btn btn-primary w-100"
                            >
                              Sign In
                            </button>
                          </div>
                        </div>
                        <div className="mt-5 pb-4 text-center">
                          <p className="mb-0 text-gray-9">
                            Copyright &copy; 2025 - PINE
                          </p>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
